// extracted by mini-css-extract-plugin
export var createdDate = "_jc-1";
export var divider = "_jc-2";
export var headerDivider = "_jc-3";
export var messagesCard = "_jc-0";
export var messagesContainer = "_jc-6";
export var messagesContainerWrapper = "_jc-4";
export var showLeftPanelButton = "_jc-8";
export var topButtons = "_jc-7";
export var withPadding = "_jc-5";